import { render, staticRenderFns } from "./CreateDossierTile.vue?vue&type=template&id=3c6f9c85&scoped=true"
import script from "./CreateDossierTile.vue?vue&type=script&lang=ts"
export * from "./CreateDossierTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f9c85",
  null
  
)

export default component.exports